<kng-loader #kngLoaderComponent [state]="loaderState" *ngIf="showPageLoader"></kng-loader>
<div class="custom-icon-widget-container" *ngIf="!isLandingPage && !environmentRef.isRaymond">
    <div class="icon-container chat-bot-widget" (click)="openChatBot()">
        <span *ngIf="unreadMessageCount > 0" class="message">
            New Message Arrived
            <span class="corner-arrow"></span>
        </span>
        <span *ngIf="unreadMessageCount > 0" class="unreadCount">{{ unreadMessageCount }}</span>
        <img class="widget-icon" src="../../assets/chatBot.svg">
    </div>
    <div class="icon-container customer-feedback-widget">
        <img class="widget-icon" src="../../assets/Feedback.png">
    </div>
</div>
<div class="main">
    <router-outlet></router-outlet>
</div>
